<template>
  <div>
    <component :is="currentIcon" />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'CertifiedIcon',
  props: {
    iconName: {
      type: String,
      required: true,
    },
  },
  mounted() {
    console.log('mounted')
  },
  computed: {
    currentIcon() {
      return defineAsyncComponent(() => import(
        /* webpackChunkName: 'misc-icon-[request]' */
        `~icons/misc/${this.iconName.toUpperCase()}.svg`
      ))
    },
  },
}
</script>
